import { GameSession } from "./game";

export type TournamentStatus = "setup" | "active" | "finished";

export interface TournamentParticipant {
  id: string;
  tournament_id: string;
  user_id: string | null;
  display_name: string;
  avatar?: string | null;
  total_score: number;
}

export interface Tournament {
  id: string;
  name: string;
  invite_code: string;
  status: TournamentStatus;
  total_games: number;
  current_game_index: number;
  created_by: string;
  created_at: string;
  finished_at?: string | null;
  settings?: Record<string, any> | null;
  
  participants: TournamentParticipant[];
  sessions: GameSession[];
}

export type TournamentWinnerMode = "points" | "wins";

export interface TournamentMatrixRow {
  player_id: string;
  display_name: string;
  avatar?: string | null;
  scores: (number | null)[];
  grand_total: number;
  wins: number; // games where this player had the top score
}

export interface TournamentMatrix {
  tournament_id: string;
  games: string[]; // session IDs
  matrix: TournamentMatrixRow[];
  winner_mode?: TournamentWinnerMode;
}

/** Rank rows by the tournament's winner mode (the other metric breaks ties). */
export function rankMatrixRows(
  rows: TournamentMatrixRow[],
  mode: TournamentWinnerMode = "points",
): TournamentMatrixRow[] {
  return [...rows].sort((a, b) =>
    mode === "wins"
      ? b.wins - a.wins || b.grand_total - a.grand_total
      : b.grand_total - a.grand_total || b.wins - a.wins,
  );
}

export type TournamentWsEvent =
  | { type: "participant_joined"; participant: TournamentParticipant }
  | { type: "participant_removed"; participant_id: string }
  | { type: "game_created"; session_id: string; invite_code: string; game_index: number }
  | { type: "tournament_finished"; winner_id: string }
  | { type: "error"; message: string };
